import React from 'react';
import { clone } from '@jd/jmtd-tools/es/object';
import DayPanel from '../DayPanel';
import TimePanel from '../TimePanel';
import DateTimePanel from '../DateTimePanel';
var DayTimePanel = {
  type: 'dayTime',
  label: '时间',
  echo: function echo(value) {
    return value === null || value === void 0 ? void 0 : value.join(' ');
  },
  render: function render(_ref) {
    var _value;

    var value = _ref.value,
        state = _ref.state,
        _update = _ref.update,
        _ref$config = _ref.config,
        _ref$config$timeConfi = _ref$config.timeConfig,
        timeConfig = _ref$config$timeConfi === void 0 ? {} : _ref$config$timeConfi,
        _ref$config$dateConfi = _ref$config.dateConfig,
        dateConfig = _ref$config$dateConfi === void 0 ? {} : _ref$config$dateConfi;
    value = clone((_value = value) !== null && _value !== void 0 ? _value : []);

    var _DayPanel$render = DayPanel.render({
      value: value[0],
      state: state,
      update: function update(newDate) {
        if (newDate) value[0] = newDate;

        _update(value);
      },
      config: dateConfig
    }),
        dayPanelDropdown = _DayPanel$render.dropdown;

    var _TimePanel$render = TimePanel.render({
      value: value[1],
      state: state,
      update: function update(newTime) {
        if (newTime) value[1] = newTime;

        _update(value);
      },
      config: timeConfig
    }),
        timePanelDropdown = _TimePanel$render.dropdown;

    return {
      defaultValue: [],
      // 历史原因兼容模式，用于disabledClose
      notCloseWhenUpdate: true,
      dropdown: /*#__PURE__*/React.createElement(DateTimePanel, {
        datePanel: dayPanelDropdown,
        timePanel: timePanelDropdown,
        state: state,
        update: _update
      })
    };
  }
};
export default DayTimePanel;